// extracted by mini-css-extract-plugin
module.exports = {"headLabel":"e_xu","title":"e_yu","subTitle":"e_zu","promoted":"e_Au"};